<template>
  <ResponsiveLayout
    sticky-actions
    :progress="progress"
    :show-kaia-logo="false"
    :show-lang-picker="false"
    theme="blue-background"
  >
    <template #header_middle>
      <div class="kds-typography-title-medium">
        {{ $t('b2b_self_test_generic_assessment') }}
      </div>
    </template>
    <div class="kds-main-wrapper self-test-complete">
      <div class="kds-content-block">
        <h3
          class="kds-typography-title-xlarge kds-typography-center"
          v-html="$t('b2b_self_test_commitment_intro_header')"
        />
        <div
          class="kds-typography-paragraph-large kds-typography-center"
          v-html="$t('b2b_self_test_commitment_intro_description')"
        />
      </div>
      <div class="self-test-complete__background" />
    </div>
    <template #actions>
      <BaseButton
        :text="$t('b2b_self_test_commitment_intro_cta')"
        data-qa="submit"
        @click="next"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import env from '@shared/env.js'
import useUserStore from '@shared/stores/useUserStore.js'
import BaseButton from '@shared/components/BaseButton.vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import { computed } from 'vue'
import { completeSelfTest } from '@shared/modules/assessment/submitSelfTest.js'

const userStore = useUserStore()

const props = defineProps({
  progress: {
    type: Number,
    default: null,
  },
  handleNextEvent: {
    type: Function,
    default: () => {},
  },
})

// MSK EU: the pre-activation answers, goal included, were submitted as a
// partial when the backend already holds a goal; send the rest. Every other
// case is a full self test. getSelfTestSteps in SelfTest.vue picks the
// screens from the same flag, so the two must agree: without a goal the MSK
// EU set ends on the program overview, which completes the full scope itself.
const scope = computed(() =>
  env.isMskEu && userStore.user?.profile?.hasSelfTestGoal
    ? 'postSignup'
    : 'full',
)

const next = async () => {
  await completeSelfTest(scope.value)
  props.handleNextEvent()
}
</script>

<style lang="scss" scoped>
.self-test-complete {
  background: url('@shared/assets/img/commitment-intro-background_fireworks.svg')
    center 86px no-repeat;
  background-size: 75%;

  &__background {
    height: 200px;
    margin-top: 32px;
    margin-bottom: -1px;
    background: url('@shared/assets/img/commitment-intro-background_people.svg')
      center bottom no-repeat;
    background-size: contain;
  }
}
</style>
